import * as types from 'modules/interventions/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

export const initialState = null;

/**
 * @param {string} _
 * @param {import('modules/interventions/types/actions').MoveKanbanInterventionAction} action
 */
const onDropCard = (_, { payload: { interventionId } }) => interventionId;

const reset = () => initialState;

export default createReducer(initialState, {
  [types.MOVE_KANBAN_INTERVENTION]: onDropCard,
  [types.MOVE_KANBAN_INTERVENTION_SUCCESS]: reset,
  [types.MOVE_KANBAN_INTERVENTION_FAILURE]: reset,
});
